const productOption = () => {
  const dataOption = document.querySelectorAll('[data-option]');

  dataOption.forEach((option) => {
    const checkedInput = option.querySelector('input:checked');
    const activeOption = option.querySelector('[data-active-option]');

    if (checkedInput && activeOption) {
      activeOption.textContent = checkedInput.value;
    }

    option.addEventListener('click', (event) => {
      const { target } = event;

      if (target.value) {
        if (activeOption) {
          activeOption.textContent = target.value;
        }
      }

      // Trigger form update for price
      const form = option.closest('form');
      if (form) {
        const variantString = target.dataset.variant;
        const variantStringFixed = variantString.replace(/&quot;/g, '"');
        const variant = JSON.parse(variantStringFixed);

        form.dispatchEvent(
          new CustomEvent('form:change', {
            detail: variant,
          }),
        );
      }

      const activeImage = target.querySelector('img[data-variant-image]');
      const productCard = option.closest('[data-product-card]');

      if (!productCard) return null;

      const productCardImage = productCard.querySelector(
        '[data-featured-card-image]',
      );

      if (productCardImage && activeImage) {
        productCardImage.innerHTML = '';

        const imageClone = activeImage.cloneNode(true);
        productCardImage.appendChild(imageClone);
      }

      return true;
    });
  });
};

export default productOption;
